import { environment } from '$env/environment';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UserAgreementUpdatingModalDismissState {
  private readonly key =
    environment.localStorageKeys.userAgreementUpdatingModalDismiss;

  public get isDismissed(): boolean {
    return localStorage.getItem(this.key) === 'true';
  }

  public set isDismissed(value: boolean) {
    localStorage.setItem(this.key, value ? 'true' : 'false');
  }

  public clear(): void {
    localStorage.removeItem(this.key);
  }
}
